import React, { useState } from 'react';
import { MPPageTitle } from '../../../../components/ui';
import UsuariosView from './components/UsuariosView/UsuariosView';
import InvitacionesView from './components/InvitacionesView/InvitacionesView';

const Usuarios: React.FC = () => {
  const [currentView, setCurrentView] = useState<'usuarios' | 'invitaciones'>('usuarios');

  return (
    <div className="flex flex-col gap-4 p-3 pb-6 lg:gap-5 lg:p-4 lg:pb-8">
      <MPPageTitle>Usuarios</MPPageTitle>

      <div className="flex justify-center">
        <div className="mp-tab-group">
          <button className={`mp-tab ${currentView === 'usuarios' ? 'mp-tab-active' : ''}`} onClick={() => setCurrentView('usuarios')}>
            Usuarios
          </button>
          <button className={`mp-tab ${currentView === 'invitaciones' ? 'mp-tab-active' : ''}`} onClick={() => setCurrentView('invitaciones')}>
            Invitaciones
          </button>
        </div>
      </div>

      {currentView === 'usuarios' ? <UsuariosView /> : <InvitacionesView />}
    </div>
  );
};

export default Usuarios;
